import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Legend, Tooltip, ResponsiveContainer } from 'recharts';

const ResumeRadarIndividual = ({ dimensions, dimensionsTotals }) => {
    if (!dimensions || !dimensionsTotals) return null;

    const radarData = dimensions.map((dim, index) => ({
        subject: dim.title,
        individual: dim.average,
        total: dimensionsTotals[index]?.average ?? 0,
    }));

    return (
        <ResponsiveContainer width="100%" height={300}>
            <RadarChart data={radarData}>
                <PolarGrid
                    radialLines
                    stroke="#ccc"
                    strokeWidth={1.5}
                />
                <PolarAngleAxis
                    dataKey="subject"
                    tick={{
                        fontSize: 11,
                        width: 200,
                    }}
                />
                <PolarRadiusAxis
                    angle={30}
                    domain={[0, 100]}
                    ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    tick={{ fontSize: 11 }}
                    axisLine={{ strokeWidth: 2 }}
                    tickLine={{ strokeWidth: 1.5 }}
                />
                <Radar
                    name="Individual"
                    dataKey="individual"
                    stroke="#008000"
                    strokeWidth={3}
                    fill="transparent"
                    dot={{ r: 3, stroke: '#008000', strokeWidth: 1, fill: '#008000' }}
                />

                <Radar
                    name="Media organizacional"
                    dataKey="total"
                    stroke="#3E246B"
                    strokeWidth={3}
                    fill="transparent"
                    dot={{ r: 3, stroke: '#3E246B', strokeWidth: 1, fill: '#3E246B' }}
                />
                <Legend />
                <Tooltip />
            </RadarChart>
        </ResponsiveContainer>
    );
};

export default ResumeRadarIndividual;
